const {
  getImpersonationHeader,
  assumeUser,
  isImpersonating,
  shouldDisableAnalytics,
  resetAnalyticsState,
  ImpersonationOverlay,
} = require("@pga/auth-flow-provider").impersonation

const AuthFlowProvider = require("@pga/auth-flow-provider").auth0
  .AuthFlowProvider
const USER_QUERY = require("../components/queries/member").USER_QUERY
const applyEducationPersonaToUser =
  require("../components/EducationPersonaSwitcher/personaLink").applyEducationPersonaToUser
const print = require("graphql").print
const fetchCurrentUser = async token => {
  try {
    const res = await fetch(
      `${process.env.REACT_APP_GRAPHQL_ENDPOINT}/graphql`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          "X-Client-Name": "account-pga-org",
          ...getImpersonationHeader(),
        },
        body: JSON.stringify({ query: print(USER_QUERY) }),
      },
    )

    const json = await res.json()
    const currentUser = json?.data?.me
    if (!currentUser) {
      throw new Error("No user found")
    }
    return [await applyEducationPersonaToUser(currentUser), null]
  } catch (err) {
    return [null, err]
  }
}
const { LoadingComponent } = require("@pga/pga-component-library")
const renderRedirecting = () => <LoadingComponent />
const AuthProvider = ({ children }) => (
  <AuthFlowProvider
    fetchCurrentUser={fetchCurrentUser}
    renderRedirecting={renderRedirecting}
  >
    {children}
  </AuthFlowProvider>
)

const PrivateRoute = require("@pga/auth-flow-provider").auth0.PrivateRoute
const RedirectToLogin = require("@pga/auth-flow-provider").auth0.RedirectToLogin
const RedirectToLogout = require("@pga/auth-flow-provider").auth0
  .RedirectToLogout
const redirectToLogout = require("@pga/auth-flow-provider").auth0
  .redirectToLogout
const RedirectToSignup = require("@pga/auth-flow-provider").auth0
  .RedirectToSignup
const withAuthProvider = require("@pga/auth-flow-provider").auth0
  .withAuthProvider
const getToken = require("@pga/auth-flow-provider").auth0.getToken

export {
  AuthProvider,
  PrivateRoute,
  RedirectToLogin,
  RedirectToLogout,
  redirectToLogout,
  RedirectToSignup,
  withAuthProvider,
  getToken,
  getImpersonationHeader,
  assumeUser,
  isImpersonating,
  shouldDisableAnalytics,
  resetAnalyticsState,
  ImpersonationOverlay,
}
